/**
 * ============================================================
 * KEJJA OS — Coming Soon Page
 * Generic placeholder for unfinished modules.
 * ============================================================
 */

import { useLocation, Link } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';

import { MODULES } from '@/lib/modules';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function ComingSoonPage() {
  const location = useLocation();
  const moduleKey = location.pathname.split('/')[1] || '';
  const mod = MODULES.find((m) => m.key === moduleKey);

  // If the URL doesn't match a known module, just default gracefully
  const ModuleIcon = mod?.icon ?? Sparkles;
  const label = mod?.label ?? 'This module';
  const tagline = mod?.tagline ?? 'Something good is on its way.';
  const description = mod?.description ?? 'Coming soon.';

  return (
    <div className="max-w-2xl mx-auto py-8">
      <Link to="/dashboard" className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-6 transition-colors">
        <ArrowLeft className="w-4 h-4 mr-1.5" />
        Back to dashboard
      </Link>

      <Card className="border-border">
        <CardContent className="p-8 md:p-12 text-center">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary mx-auto flex items-center justify-center mb-6">
            <ModuleIcon className="w-8 h-8" />
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-foreground">
            {label}
          </h1>
          <p className="text-lg text-primary mt-1.5 italic font-medium">
            {tagline}
          </p>
          <p className="text-sm text-muted-foreground mt-4 max-w-md mx-auto leading-relaxed">
            {description}
          </p>

          <div className="mt-8 border-t border-border pt-6 text-xs text-muted-foreground">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-muted">
              <Sparkles className="w-3.5 h-3.5" />
              <span className="font-medium">In active development</span>
            </div>
            <p className="mt-4 max-w-md mx-auto">
              KEJJA is being built alongside your family's story — module by module, with care.
              This feature is coming in a future release.
            </p>
          </div>

          <div className="mt-8">
            <Button asChild variant="default">
              <Link to="/dashboard">
                Go to dashboard
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

